$(function() {
	$(".section-header").addClass("is-fixed");
    $(".section-header").css({
        "display":"block"
    });
	var headerHeight = $('.announcement-bar').outerHeight(); 
    $(".section-header").css({
        "top": headerHeight

    });
  
    $(window).on("scroll", function() {
        if ($(this).scrollTop() > 100) {
            //$(".section-header").removeClass("is-fixed");
            //$(".section-header").addClass("is-fixed");
            
		    $(".section-header").css({
		        "top": 0

		    });
            
        } else {
			$(".section-header").addClass("is-fixed");

            
		    $(".section-header").css({
		        "top": headerHeight

		    });
            
        }
    });

})
